/** Health check polling interval in milliseconds. */
export const HEALTH_POLL_INTERVAL = 30_000;
